<template>
  <v-container fluid :fill-height="loading" class="users-list" :pa-0="$vuetify.breakpoint.xsOnly">

    <v-progress-linear style="position: fixed; left: 0; right: 0; margin: 0; z-index: 99;" :style="{top: $vuetify.breakpoint.smAndDown ? '54px' : '62px'}" color="primary lighten-2" height="2" v-show="subtleLoading" :indeterminate="true"></v-progress-linear>

    <v-app-bar :color="$vuetify.breakpoint.xsOnly ? 'secondary' : 'secondary'" dark fixed app :elevate-on-scroll="$vuetify.breakpoint.smAndDown">

      <template v-if="$vuetify.breakpoint.mdAndDown">
        <hb-main-menu-button />
      </template>

      <v-toolbar-title style="margin-left: 0; width: 100%;">
        <v-text-field
          :placeholder="`${$t('user_management.search')}...`"
          v-model="searchPhrase"
          class="topbar-search"
          style="font-size: 20px;"
          single-line
          full-width
          clearable
          hide-details
        >
          <v-icon style="cursor: pointer;" slot="append">search</v-icon>
        </v-text-field>
      </v-toolbar-title>

      <v-spacer></v-spacer>

    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle />

    <v-fade-transition>
      <v-row v-if="!loading" no-gutters>
        <v-col cols="12" sm="8" lg="9" xl="10" :style="{height: $vuetify.breakpoint.xsOnly ? '0' : 'auto'}">
          <add-user-dialog @on-dismiss="onAddUserDialogDismiss" :roles="roles" />
        </v-col>
        <v-col cols="12" sm="4" lg="3" xl="2">
          <v-select
            v-model="filter"
            :items="filterOptions"
            :placeholder="`${$t('user_management.filtered')} 0 ${$t('user_management.selections')}`"
            item-text="desc"
            item-value="value"
            multiple
            hide-details
            single-line
            solo
            prepend-inner-icon="filter_list"
            background-color="secondary lighten-1"
            :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : ''"
          >
            <template v-slot:selection="{ item, index }">
              <template v-if="filter.length !== filterOptions.length && index === 0">
                <span class="grey--text mr-1">{{ $t('user_management.filtered') }}</span>
                <span class="grey--text caption">({{ filter.length }} {{ $t('user_management.selections') }})</span>
              </template>
              <template v-else>
                <span v-if="index === 0" class="grey--text">{{ $t('user_management.show_all') }}</span>
              </template>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" v-if="(filteredAgentUsers.length > 0 && !cloudUsersAreFilteredOut) || (filteredCloudUsers.length > 0 && !agentUsersAreFilteredOut)" :pb-5="$vuetify.breakpoint.xsOnly">
          <v-list two-line color="transparent" class="pa-0">
            <v-list-item class="users-header" v-if="$vuetify.breakpoint.smAndUp">
              <v-list-item-avatar></v-list-item-avatar>
              <v-list-item-content class="grey--text">
                <v-container fluid ma-0 pa-0>
                  <v-row align="center" justify="center" class="fill-height" ma-0>
                    <v-col cols="12" sm="6" lg="5" xl="3">
                      <span class="caption">{{ $t('user_management.user') }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" lg="7" xl="9">
                      <span class="caption">{{ $t('user_management.roles') }}</span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-list-item-content>
              <v-list-item-action style="width: 36px;"></v-list-item-action>
            </v-list-item>
            <v-divider v-if="$vuetify.breakpoint.smAndUp"></v-divider>
            <users-list v-if="filter.findIndex(f => f === 1) > -1" :users="filteredAgentUsers" :allRoles="roles" type="agent" @reload-users="reloadAgentUsers" />
            <users-list v-if="filter.findIndex(f => f === 0) > -1" :users="filteredCloudUsers" :allRoles="roles" type="user" @reload-users="reloadCloudUsers" />
          </v-list>
        </v-col>
      </v-row>
    </v-fade-transition>

  </v-container>
</template>

<script>
  import axios from 'axios';
  import UsersList from '../components/UserManagement/UsersList.vue';
  import AddUserDialog from '../components/UserManagement/AddUserDialog.vue';

  export default {
    name: "UserManagementView",
    components: {
      UsersList: UsersList,
      AddUserDialog: AddUserDialog,
    },
    data() {
      return {
        loading: true,
        subtleLoading: false,
        searchPhrase: '',
        cloudUsers: [],
        agentUsers: [],
        roles: [],
        filter: [0,1,2,3],
        filterOptions: [
          { desc: "Tavalliset käyttäjät", value: 0 },
          { desc: "Jaetut käyttäjät", value: 1 },
          { desc: "Aktiiviset", value: 2 },
          { desc: "Ei aktiiviset", value: 3 },
        ],
      }
    },
    methods: {
      onAddUserDialogDismiss() {
        this.getAllUsers();
      },
      reloadAgentUsers() {
        return axios.get('/api/user/list-agent')
          .then(res => {
            this.agentUsers = res.data;
          })
          .catch(err => {
            console.log(err);
          });
      },
      reloadCloudUsers() {
        return axios.get('/api/user/list-cloud')
          .then(res => {
            this.cloudUsers = res.data;
          })
          .catch(err => {
            console.log(err);
          });
      },
      async getAllUsers() {
        if (this.agentUsers.length > 0 || this.cloudUsers.length > 0) {
          this.subtleLoading = true;
        } else {
          this.loading = true;
        }
        await this.reloadCloudUsers();
        await this.reloadAgentUsers();
        this.loading = false;
        this.subtleLoading = false;
      },
      filterUsers(users) {
        const filteredUsers = users;

        const filterOutActive = this.filter.findIndex(f => f === 2) === -1;
        const filterOutInactive = this.filter.findIndex(f => f === 3) === -1;

        if ((this.searchPhrase == null || this.searchPhrase.length === 0) && !filterOutActive && !filterOutInactive) {
          return filteredUsers;
        }

        const searchPhraseLower = this.searchPhrase.toLowerCase();
        const searchPhraseArray = searchPhraseLower.split(" ");
        return filteredUsers.filter(user => {
          let found = [];
          const lowerSearchedString =
            (user.email ? user.email.toLowerCase() : '') +
            (user.subject ? user.subject.toLowerCase() : '') +
            (user.roleSet.length > 0 ? user.roleSet.join(' ').toLowerCase() : '');
          searchPhraseArray.forEach(phrase => {
            if (lowerSearchedString.indexOf(phrase) !== -1) {
              found.push(true);
            } else {
              found.push(false);
            }
          })
          if (filterOutActive && user.enabled) found.push(false);
          if (filterOutInactive && !user.enabled) found.push(false);
          return found.indexOf(false) === -1;
        })
      },
      getAllRoles() {
        axios.get(`/api/user/roles`)
          .then(res => {
            const allowedRoles = ['basic', 'admin', 'superior'];
            this.roles = res.data.filter(r => allowedRoles.indexOf(r) > -1);
          })
          .catch(err => {
            console.log(err);
          });
      },
    },
    computed: {
      filteredAgentUsers() {
        return this.filterUsers(this.agentUsers);
      },
      filteredCloudUsers() {
        return this.filterUsers(this.cloudUsers);
      },
      agentUsersAreFilteredOut() {
        return this.filter.findIndex(f => f === 1) === -1;
      },
      cloudUsersAreFilteredOut() {
        return this.filter.findIndex(f => f === 0) === -1;
      },
    },
    mounted() {
      this.getAllUsers();
      this.getAllRoles();
    },
  }
</script>

<style lang="scss">
  .users-header {
    .v-list__tile {
      height: 30px;
    }
  }
</style>
